import Vue from "vue";
import App from "./App";
import router from "./router";
import "@/icons";
import ant from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import "@/assets/css/common.css";

import "default-passive-events";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
Vue.use(ant);
Vue.config.productionTip = false;
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3
});

// 添加路由守卫拦截，判断用户登录状态以跳转到对应页面
// router.beforeEach((to, from, next) => {
//   let token = sessionStorage.getItem("name");

//   if (!token && to.name !== "login" && to.name !== "ForgetPwd") {
//     next({ path: "/login" });
//   } else if (
//     (token && to.path === "/login") ||
//     (token && to.name == "ForgetPwd")
//   ) {
//     next({ path: "/Index" });
//   } else {
//     NProgress.start();
//     next();
//   }
// });
// router.afterEach(() => {
//   NProgress.done();
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js